import { LineOfCredit } from "redux-models/reduxStateTypes";
import {
  LOC_CREATE_APPLICATION_FAILURE,
  LOC_CREATE_APPLICATION_REQUEST,
  LOC_CREATE_APPLICATION_SUCCESS,
  LOC_CREATE_CUSTOMER_FAILURE,
  LOC_CREATE_CUSTOMER_REQUEST,
  LOC_CREATE_CUSTOMER_SUCCESS,
  LOC_FINANCING_NEEDS_FAILURE,
  LOC_FINANCING_NEEDS_REQUEST,
  LOC_FINANCING_NEEDS_SUCCESS,
  LOC_GET_APPLICATION_FAILURE,
  LOC_GET_APPLICATION_REQUEST,
  LOC_GET_APPLICATION_SUCCESS,
  LOC_GET_BROKER_FAILURE,
  LOC_GET_BROKER_REQUEST,
  LOC_GET_BROKER_SUCCESS,
  LOC_GET_CUSTOMER_DETAILS_FAILURE,
  LOC_GET_CUSTOMER_DETAILS_REQUEST,
  LOC_GET_CUSTOMER_DETAILS_SUCCESS,
  LOC_GET_FILES_FAILURE,
  LOC_GET_FILES_REQUEST,
  LOC_GET_FILES_SUCCESS,
  LOC_GET_RULES_SUMMARY_FAILURE,
  LOC_GET_RULES_SUMMARY_REQUEST,
  LOC_GET_RULES_SUMMARY_SUCCESS,
  LOC_REMOVE_ITEM_AT_PATH,
  LOC_RESET_STATE,
  LOC_CLEAR_APPLICATION_DATA,
  LOC_SELECT_BROKER,
  LOC_SELECT_MANAGER,
  LOC_SET_ITEM_AT_PATH,
  LOC_SUBMIT_APPLICATION_FAILURE,
  LOC_SUBMIT_APPLICATION_REQUEST,
  LOC_SUBMIT_APPLICATION_SUCCESS,
  LOC_UPDATE_CUSTOMER_ADDRESS_DETAILS,
  LOC_UPDATE_CUSTOMER_FAILURE,
  LOC_UPDATE_CUSTOMER_REQUEST,
  LOC_UPDATE_CUSTOMER_SUCCESS,
  LOC_UPDATE_OFFICE_HOLDERS_FAILURE,
  LOC_UPDATE_OFFICE_HOLDERS_REQUEST,
  LOC_UPDATE_OFFICE_HOLDERS_SUCCESS,
  LOC_UPLOAD_FILE_FAILURE,
  LOC_UPLOAD_FILE_REQUEST,
  LOC_UPLOAD_FILE_SUCCESS,
} from "actions/types";
import {
  removeItemAtPathRedux,
  setItemAtPathRedux,
  updateCustomerAddressDetails,
} from "helpers/data-helpers/itemAtPath";
import { mapApiToReduxLocCustomer } from "helpers/mappers";
import { loadingState, unloadingState } from "helpers/reducerHelpers";
import cloneDeep from "lodash/cloneDeep";
import {
  mapApiErrorToReduxState,
  mapApiToLocFinanceNeeds,
  Merge,
} from "helpers/mappers";
import { HttpErrorAction } from "utils/api";

const initialState: LineOfCredit = {
  error: null,
  recommendation: null,
  applicationId: null,
  loading: false,
  isSubmitted: false,
  submittedDate: null,
  brokerInfo: null,
  form: {
    manager: null,
    broker: null,
    customerName: undefined,
    authorizationCheck: false,
    structure: null,
    selectedCustomerId: null,
    documents: [],
    isSubmitted: false,
    clientDetails: undefined,
    businessDetails: undefined,
    financeNeeds: undefined,
  },
};

const lineOfCredit = (
  state: LineOfCredit = initialState,
  action: { type: string; payload: any } | HttpErrorAction
): LineOfCredit => {
  switch (action.type) {
    case LOC_GET_APPLICATION_REQUEST:
      return loadingState(state, action.type);
    case LOC_GET_APPLICATION_SUCCESS: {
      const res = action.payload;

      return {
        ...unloadingState(state, action.type),
        applicationId: res.id,
        isSubmitted: res.isSubmitted,
        submittedDate: res.submitted,
        brokerInfo: res.brokerInfo,

        form: {
          ...state.form,
          selectedCustomerId: res.customerId,
          manager: res.managerInfo,
          financeNeeds: mapApiToLocFinanceNeeds(res),
        },
      };
    }
    case LOC_GET_APPLICATION_FAILURE:
      return mapApiErrorToReduxState(action, state);

    case LOC_GET_RULES_SUMMARY_REQUEST:
      return loadingState(state, action.type);
    case LOC_GET_RULES_SUMMARY_SUCCESS:
      return {
        ...unloadingState(state, action.type),
        locRules: action.payload,
      };
    case LOC_GET_RULES_SUMMARY_FAILURE:
      return mapApiErrorToReduxState(action, state);

    case LOC_GET_CUSTOMER_DETAILS_REQUEST:
      return loadingState(state, action.type);
    case LOC_GET_CUSTOMER_DETAILS_SUCCESS: {
      const mappedResponse = mapApiToReduxLocCustomer({
        resp: action.payload,
        state: state.form,
        strategy: Merge.All,
      });
      return {
        ...unloadingState(state, action.type),
        form: {
          ...state.form,
          ...mappedResponse,
        },
      };
    }
    case LOC_GET_CUSTOMER_DETAILS_FAILURE:
      return mapApiErrorToReduxState(action, state);

    case LOC_CREATE_CUSTOMER_REQUEST:
      return loadingState(state, action.type);
    case LOC_CREATE_CUSTOMER_SUCCESS:
      const mappedResponse = mapApiToReduxLocCustomer({
        resp: action.payload,
        state: state.form,
        strategy: Merge.All,
      });
      return {
        ...unloadingState(state, action.type),
        form: {
          ...state.form,
          ...mappedResponse,
        },
      };
    case LOC_CREATE_CUSTOMER_FAILURE:
      return mapApiErrorToReduxState(action, state);

    case LOC_UPDATE_CUSTOMER_REQUEST:
      return loadingState(state, action.type);
    case LOC_UPDATE_CUSTOMER_SUCCESS: {
      const mappedResponse = mapApiToReduxLocCustomer({
        resp: action.payload,
        state: state.form,
        strategy: Merge.Business,
      });
      return {
        ...unloadingState(state, action.type),
        form: {
          ...state.form,
          ...mappedResponse,
        },
      };
    }
    case LOC_UPDATE_CUSTOMER_FAILURE:
      return mapApiErrorToReduxState(action, state);

    case LOC_UPDATE_OFFICE_HOLDERS_REQUEST:
      return loadingState(state, action.type);
    case LOC_UPDATE_OFFICE_HOLDERS_SUCCESS: {
      const mappedResponse = mapApiToReduxLocCustomer({
        resp: action.payload,
        state: state.form,
        strategy: Merge.Clients,
      });
      return {
        ...unloadingState(state, action.type),
        form: {
          ...state.form,
          ...mappedResponse,
        },
      };
    }
    case LOC_UPDATE_OFFICE_HOLDERS_FAILURE:
      return mapApiErrorToReduxState(action, state);

    case LOC_CREATE_APPLICATION_REQUEST:
      return loadingState(state, action.type);
    case LOC_CREATE_APPLICATION_SUCCESS:
      return {
        ...unloadingState(state, action.type),
        applicationId: action.payload.id,
        form: {
          ...state.form,
          selectedCustomerId: action.payload.customerId,
        },
      };
    case LOC_CREATE_APPLICATION_FAILURE:
      return mapApiErrorToReduxState(action, state);

    case LOC_GET_FILES_REQUEST:
      return loadingState(state, action.type);
    case LOC_GET_FILES_SUCCESS:
      return {
        ...unloadingState(state, action.type),
        form: {
          ...state.form,
          documents: action.payload.documents,
        },
      };
    case LOC_GET_FILES_FAILURE:
      return mapApiErrorToReduxState(action, state);

    case LOC_UPLOAD_FILE_REQUEST:
      return loadingState(state, action.type);
    case LOC_UPLOAD_FILE_SUCCESS:
      return {
        ...unloadingState(state, action.type),
        form: {
          ...state.form,
          documents: [action.payload, ...state.form.documents],
        },
      };
    case LOC_UPLOAD_FILE_FAILURE:
      return mapApiErrorToReduxState(action, state);

    case LOC_SUBMIT_APPLICATION_REQUEST:
      return loadingState(state, action.type);
    case LOC_SUBMIT_APPLICATION_SUCCESS:
      const res = action.payload;

      return {
        ...unloadingState(state, action.type),
        isSubmitted: true,
        submittedDate: res.submitted,
        brokerInfo: res.brokerInfo,
      };
    case LOC_SUBMIT_APPLICATION_FAILURE:
      return mapApiErrorToReduxState(action, state);

    case LOC_SET_ITEM_AT_PATH:
      return setItemAtPathRedux(state, action);
    case LOC_REMOVE_ITEM_AT_PATH:
      return removeItemAtPathRedux(state, action);

    case LOC_UPDATE_CUSTOMER_ADDRESS_DETAILS:
      return updateCustomerAddressDetails(state, action);

    case LOC_RESET_STATE:
      return initialState;

    case LOC_CLEAR_APPLICATION_DATA: {
      // reset in-progress application/customer data but keep broker + BDM
      const cleared = cloneDeep(initialState);
      cleared.form.broker = state.form.broker;
      cleared.form.manager = state.form.manager;
      return cleared;
    }

    case LOC_SELECT_MANAGER:
      return {
        ...state,
        form: {
          ...state.form,
          manager: action.payload,
        },
      };

    case LOC_SELECT_BROKER:
      const newState = cloneDeep(initialState);
      newState.form.broker = action.payload;
      // BDM is not broker-specific; keep it across broker (re)selection
      newState.form.manager = state.form.manager;
      return newState;

    case LOC_GET_BROKER_REQUEST:
      return loadingState(state, action.type);
    case LOC_GET_BROKER_SUCCESS:
      const user = action.payload;

      return {
        ...unloadingState(state, action.type),
        form: {
          ...state.form,
          broker: {
            id: user.id,
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
            companyName: user.company?.name,
            address: user.company?.address,
            role: user.role,
            status: user.status,
          },
        },
      };
    case LOC_GET_BROKER_FAILURE:
      return mapApiErrorToReduxState(action, state);

    case LOC_FINANCING_NEEDS_REQUEST:
      return loadingState(state, action.type);
    case LOC_FINANCING_NEEDS_SUCCESS: {
      return {
        ...unloadingState(state, action.type),
        form: {
          ...state.form,
          financeNeeds: mapApiToLocFinanceNeeds(action.payload),
        },
      };
    }
    case LOC_FINANCING_NEEDS_FAILURE:
      return mapApiErrorToReduxState(action, state);

    default:
      return state;
  }
};

export default lineOfCredit;
